import { z } from "zod";
import { caughtExceptionToolOutputSchema } from "./caughtExceptionToolOutput.js";
import { mastraErrorOutputSchema } from "./mastraErrorToolOutput.js";
const errorToolOutputSchema = z.union([
  mastraErrorOutputSchema,
  caughtExceptionToolOutputSchema
]);
function checkIsErrorToolOutput(value) {
  return errorToolOutputSchema.safeParse(value).success;
}
function withErrorToolOutput(successSchema) {
  return z.union([successSchema, errorToolOutputSchema]);
}
export {
  checkIsErrorToolOutput,
  errorToolOutputSchema,
  withErrorToolOutput
};
//# sourceMappingURL=errorToolOutput.js.map
